import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=6458cabf&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=js"
export * from "./CalendarView.vue?vue&type=script&lang=js"
import style0 from "./CalendarView.vue?vue&type=style&index=0&id=6458cabf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458cabf",
  null
  
)

export default component.exports